import Attributions from '../pages/attributions'
import Collaborations from '../pages/collaborations'
import Contribution from '../pages/contribution'
import Description from '../pages/description'
import CommAndEducation from '../pages/commAndEducation'
import Engineering from '../pages/engineering'
import Experiments from '../pages/experiments'
import Home from '../pages/home'
import HumanPractices from '../pages/human-practices'
import Implementation from '../pages/implementation'
import Model from '../pages/model'
import Notebook from '../pages/notebook'
import Results from '../pages/results'
import Safety from '../pages/safety'
import Team from '../pages/team'

enum Routes {
  Attributions = 'attributions',
  Collaborations = 'collaborations',
  Contribution = 'contribution',
  Description = 'description',
  CommAndEducation = 'education',
  Engineering = 'engineering',
  Entrepreneurship = 'entrepreneurship',
  Experiments = 'experiments',
  Hardware = 'hardware',
  Home = '',
  HumanPractices = 'human-practices',
  Implementation = 'implementation',
  Improve = 'improve',
  Inclusivity = 'inclusivity',
  Measurement = 'measurement',
  Model = 'model',
  Notebook = 'notebook',
  PartCollection = 'part-collection',
  Partnership = 'partnership',
  Plant = 'plant',
  Results = 'results',
  Safety = 'safety',
  Software = 'software',
  Sustainable = 'sustainable',
  Team = 'team',
}

interface RoutesComponents {
  route: Routes
  component: Function
}

interface TreeNode {
  name: string
  link: Routes
}

interface Tree {
  name: string
  children: TreeNode[]
}

const RoutesComponentsMapper: RoutesComponents[] = [
  {
    route: Routes.Attributions,
    component: Attributions
  },
  {
    route: Routes.Collaborations,
    component: Collaborations
  },
  {
    route: Routes.Contribution,
    component: Contribution
  },
  {
    route: Routes.Description,
    component: Description
  },
  {
    route: Routes.CommAndEducation,
    component: CommAndEducation
  },
  {
    route: Routes.Engineering,
    component: Engineering
  },
  {
    route: Routes.Experiments,
    component: Experiments
  },
  {
    route: Routes.Home,
    component: Home
  },
  {
    route: Routes.HumanPractices,
    component: HumanPractices
  },
  {
    route: Routes.Implementation,
    component: Implementation
  },
  {
    route: Routes.Model,
    component: Model
  },
  {
    route: Routes.Notebook,
    component: Notebook
  },
  {
    route: Routes.Results,
    component: Results
  },
  {
    route: Routes.Safety,
    component: Safety
  },
  {
    route: Routes.Team,
    component: Team
  }
]

const ProjectTree: Tree = {
  name: 'Project',
  children: [
    {
      name: 'Description',
      link: Routes.Description
    },
    {
      name: 'Engineering Success',
      link: Routes.Engineering
    },
    {
      name: 'Implementation',
      link: Routes.Implementation
    },
    {
      name: 'Safety',
      link: Routes.Safety
    }
  ]
}

const WetAndDryLabTree: Tree = {
  name: 'Wet & Dry lab',
  children: [
    {
      name: 'Contribution',
      link: Routes.Contribution
    },
    {
      name: 'Experiments',
      link: Routes.Experiments
    },
    {
      name: 'Modelling',
      link: Routes.Model
    },
    {
      name: 'Results',
      link: Routes.Results
    }
  ]
}

const CommunicationTree: Tree = {
  name: 'Communication',
  children: [
    {
      name: 'Human Practices',
      link: Routes.HumanPractices
    },
    {
      name: 'Communication & Education',
      link: Routes.CommAndEducation
    }
  ]
}

const TeamTree: Tree = {
  name: 'Team',
  children: [
    {
      name: 'Team',
      link: Routes.Team
    },
    {
      name: 'Notebook',
      link: Routes.Notebook
    },
    {
      name: 'Attributions',
      link: Routes.Attributions
    }
  ]
}

const Trees: Tree[] = [
  ProjectTree,
  WetAndDryLabTree,
  TeamTree,
  CommunicationTree
]

export { Routes, RoutesComponentsMapper, Trees }
